import { render, staticRenderFns } from "./buyer-transaction.vue?vue&type=template&id=a0d51682&scoped=true&"
import script from "./buyer-transaction.vue?vue&type=script&lang=js&"
export * from "./buyer-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d51682",
  null
  
)

export default component.exports